<div
  class="flex flex-col justify-center gap-5 p-4 lg:gap-20 lg:px-20 w-full h-full"
>
  <div
    class="lg:hidden flex gap-2 items-center font-light"
    [routerLink]="['/refreshments']"
  >
    <ng-icon name="heroArrowLeft"></ng-icon>
    Back
  </div>
  <div
    class="w-full h-full flex flex-col justify-center gap-5 lg:gap-8 lg:flex-row"
  >
    @if (loadingDetails) {
    <div class="flex flex-col h-[400px] w-full lg:w-[549px]">
      <ui-skeleton
        class="h-full w-full"
        kind="image"
        size="h-full w-full"
      ></ui-skeleton>
    </div>
    <div
      class="flex flex-col gap-6 w-full lg:shadow-detail lg:h-[640px] lg:w-[549px] rounded-[16px]"
    >
      <ui-skeleton
        class="w-full h-full"
        kind="image"
        size="w-full h-full"
      ></ui-skeleton>
    </div>
    } @else {
    <div class="flex flex-col h-[400px] w-full lg:w-[549px]">
      <ui-slider
        class="w-full h-full"
        [images]="[
          'assets/images/products/' + refreshment.code + '.jpg' | placeholder
        ]"
      ></ui-slider>
      <div></div>
    </div>
    <div
      class="flex flex-col gap-6 w-full lg:shadow-detail lg:h-[640px] lg:w-[549px] rounded-[16px] lg:px-9 lg:py-7"
    >
      <div class="flex flex-col gap-2">
        <div class="flex justify-between items-center">
          <span class="font-semibold text-[24px]">{{ refreshment.name }}</span>
          @if(promotion) {
          <ui-badge
            [color]="'orange'"
            [badgeText]="'-' + promotion + '%'"
          ></ui-badge>
          }
        </div>
        <p class="font-light">
          Filtered coffee is a style of coffee prepared by slowly passing
          simmering water through a coffee filter filled with ground coffee.
        </p>
      </div>
      @if (hasSize(ProductUnit.SMALL) || hasSize(ProductUnit.MEDIUM) ||
      hasSize(ProductUnit.LARGE)){
      <div class="w-full flex flex-col gap-2">
        <div>
          <h6 class="font-light">Size</h6>

          <div class="flex gap-4 justify-between items-center h-10 text-[14px]">
            @if (hasSize(ProductUnit.SMALL)){
            <div
              class="cursor-pointer h-full w-full border-[1.5px] border-neutral-50 flex justify-center items-center rounded-[36px] font-light text-neutral-20 hover:border-brown-seed hover:text-brown-seed [&.active]:hover:text-white [&.active]:border-brown-seed"
              [ngClass]="{
                'active bg-brown-seed text-white': size === ProductUnit.SMALL
              }"
              (click)="selectSize(ProductUnit.SMALL)"
            >
              Small
            </div>
            } @if (hasSize(ProductUnit.MEDIUM)){
            <div
              class="cursor-pointer h-full w-full border-[1.5px] border-neutral-50 flex justify-center items-center rounded-[36px] currentPrice.amount font-light hover:border-brown-seed hover:text-brown-seed [&.active]:hover:text-white [&.active]:border-brown-seed"
              [ngClass]="{
                'active bg-brown-seed text-white': size === ProductUnit.MEDIUM
              }"
              (click)="selectSize(ProductUnit.MEDIUM)"
            >
              Medium
            </div>
            } @if (hasSize(ProductUnit.LARGE)){ @if (hasSize(ProductUnit.LARGE))
            {
            <div
              class="cursor-pointer h-full w-full border-[1.5px] border-neutral-50 flex justify-center items-center rounded-[36px] currentPrice.amount font-light hover:border-brown-seed hover:text-brown-seed [&.active]:hover:text-white [&.active]:border-brown-seed"
              [ngClass]="{
                'active bg-brown-seed text-white': size === ProductUnit.LARGE
              }"
              (click)="selectSize(ProductUnit.LARGE)"
            >
              Large
            </div>
            } }
          </div>
        </div>
      </div>
      }
      <div>
        <ui-counter
          description="Quantity"
          [style]="'detail'"
          (quantityEmitter)="getCounterNumber($event)"
          >{{ quantity }}</ui-counter
        >
      </div>
      <div
        class="h-[156px] w-full bg-gray-10 border-[1.5px] border-brown-seed p-4 rounded-[16px] flex flex-col gap-4"
      >
        @if ( hasSize(ProductUnit.SMALL) || hasSize(ProductUnit.MEDIUM) ||
        hasSize(ProductUnit.LARGE)){
        <div class="flex justify-between font-light">
          <span>Size :</span>
          <span>{{ size }}</span>
        </div>
        }

        <div class="flex justify-between font-light">
          <span>Quantity :</span>
          <span>{{ quantity }}</span>
        </div>
        <div
          class="flex justify-between items-center font-semibold text-[18px]"
        >
          <span>Total :</span>
          <div class="flex flex-col items-end">
            @if (promotion) {
            <span
              class="line-through text-neutral-50 text-[14px] flex w-full justify-end font-light"
              >{{ refreshment.normalPrice.amount | currency }}</span
            >
            }
            <span>{{ total | currency }}</span>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row justify-center items-center gap-5">
        <button
          ui-portal-button
          [style]="'teal'"
          [isFull]="true"
          class="flex gap-2 transition duration-300 hover:bg-teal-700"
          (click)="displayCart()"
        >
          Order <ng-icon name="heroArrowRight" size="24px"></ng-icon>
        </button>
        <button
          ui-portal-button
          class="flex gap-2"
          [isFull]="true"
          [style]="'outline'"
          (click)="addToCart(refreshment)"
        >
          <ng-icon name="hugeShoppingBasketAdd03" size="24px"></ng-icon> Add to
          cart
        </button>
      </div>
    </div>
    }
  </div>
  <div class="flex flex-col h-full w-full gap-5 md:items-center">
    @if(loadingRefreshments) {
    <div class="w-full h-7">
      <ui-skeleton
        class="flex justify-start max-w-[500px]"
        kind="text"
        size="h-7"
      ></ui-skeleton>
    </div>
    <ui-swiper [showArrow]="false">
      @for (offer of [0,0,0,0,0]; track $index) {
      <ui-skeleton kind="image" size="w-[220px] h-[180px]"></ui-skeleton>
      }
    </ui-swiper>
    } @else {
    <p class="w-full flex justify-start">You may also like</p>
    <ui-swiper [showArrow]="false">
      @for (recommendation of recommendations; track $index) { @if ($index < 3)
      {
      <ui-card
        class="cursor-pointer"
        [image]="'assets/images/products/' + recommendation.code + '.jpg'"
        [title]="recommendation.name"
        [routerLink]="['/refreshments', recommendation.id]"
        [description]="recommendation.currentPrice.amount | currency"
      ></ui-card>
      } }
    </ui-swiper>
    }
  </div>
</div>
